module.exports = __webpack_public_path__ + "static/media/tela-agenda-prontlife.3bd7f979.png";